import { registerFeature } from '../operationRegistry';
import { api } from '../../api';

export function registerUserPreferencesOperations(): void {
  registerFeature({
    name: 'userPreferences',
    invalidateKeys: [['auth-user']],
    operations: [
      {
        type: 'USER_PREFERENCES_UPDATE',
        collapseRule: 'lastWins',
        /** Collapse repeated toggles of the same key to the latest value. */
        collapseKeyFn: (p) => 'prefs:' + Object.keys(p).sort().join(','),
        async execute(payload) {
          await api('/user/preferences', {
            method: 'PATCH',
            body: JSON.stringify(payload),
          });
          return undefined;
        },
      },
    ],
  });
}
